<template>
  <div id="app">
    <!-- <LanguageFloatBall /> -->
    <router-view />
  </div>
</template>

<script>
import { GetadminsetList } from "@/setAxios.js";
import LanguageFloatBall from "@/components/LanguageFloatBall/LanguageFloatBall.vue";
export default {
  components: { LanguageFloatBall },
  data() {
    return {
      transitionName: "",
    };
  },
  name: "App",
  async created() {
    this.copyVuex();
    if (!this.$store.state.adminSetting.isHave) {
      let res = await GetadminsetList();
      if (res.Data) {
        this.$store.state.adminSetting.isHave = true;
        if (res.Data.adst05) {
          this.$store.state.adminSetting.adst05 =
            this.$store.state.baseUrl + res.Data.adst05;
        }
        if (res.Data.adst03) {
          this.$store.state.adminSetting.adst03 = res.Data.adst03;
        }
        if (res.Data.adst04) {
          this.$store.state.adminSetting.ptbaArr = JSON.parse(res.Data.adst04);
        }
        if (res.Data.adst06) {
          this.$store.state.adminSetting.adst06 =
            this.$store.state.baseUrl + res.Data.adst06;
        }
      }
    }
    if (this.$store.state.adminSetting.adst03 != "") {
      document.title = this.$store.state.adminSetting.adst03;
    }
    // if (this.$store.state.adminSetting.adst05 != "") {
    //   var link = document.querySelector('link[rel*="icon"]');
    //   link.href = this.$store.state.adminSetting.adst05;
    // }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        $(document).ready(function () {
          $('iframe').on('load', function () {
            const iframeDoc = $(this).contents()[0];
            const targetElements = $(iframeDoc).find('.language-float-ball');
            targetElements.remove()
          });
        });

      },
      deep: true
    }
  },
  mounted() {
  },
  beforeDestroy() { },
};
</script>
<style lang="scss">
.number-input {
  -moz-appearance: textfield;
}

.number-input::-webkit-outer-spin-button,
.number-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


.iconfont {
  margin-right: 5px;
  margin-left: 2.5px;
  font-size: 18px !important;
  color: #fff;
}

.el-menu-item,
.el-submenu__title {
  font-weight: bold;
  letter-spacing: 3px;
}

.el-dropdown-menu {
  .popper__arrow::after {
    top: 1px;
    margin-left: -6px;
    border-top-width: 0;
    border-bottom-color: #1f2d3d !important;
  }
}

.el-dropdown-menu {
  background-color: #1f2d3d !important;
}

.el-dropdown-menu::before,
.el-dropdown-menu__item--divided::before {
  display: none;
}

.el-submenu .el-menu-item {
  height: 50px;
  line-height: 50px;
  // background: none !important;
  min-width: 180px;
  padding: 0 !important;
}

.el-submenu .el-menu {
  background: #066fb1 !important;
}

.el-menu {
  span {
    // display: inline-block;
    // width: 165px;
    // height: 35px;
    // line-height: 35px;
  }
}

.el-menu-item {

  // padding: 0 !important;
  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #fff;
    position: absolute;
    top: 21px;
    left: 35px;
  }
}

// .control .el-menu-item {
//   img {
//     content: url('./assets/img/6.0/未选中.png');
//   }
// }

// 侧边栏样式开始
.el-menu-item.is-active {

  // span {
  //   i {
  //     color: rgb(236, 142, 0);
  //   }
  //   display: inline-block;
  //   height: 35px;
  //   line-height: 35px;
  //   background: #38c6ff;
  //   border-radius: 10px;
  //   margin-left: 20px;
  // }
  img {
    content: url('./assets/img/6.0/选中.png');
  }
}

// 渐变色
.jb {
  // background: linear-gradient(to right, #4f6dfa, #5aa6f9);
  background: linear-gradient(to right, #2f2f2f, #535353);
  height: 60px;
}

// 全局饿了么tree宽度自适应
.el-tree {
  min-width: 100%;
  display: inline-block;
}

span {
  outline: none;
}

.testAnimation-enter,
.testAnimation-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

#drag {
  cursor: pointer;
  // transition: all 0.5s ease;
  position: absolute;
  left: 20px;
  top: 20px;
  width: 200px;
  background-color: rgba(0, 0, 0, 0);

  .Yuan {
    transition: all 0.5s ease;
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    box-shadow: 0 0 10px 2px rgba(146, 146, 146, 0.493);
    background-color: rgb(255, 255, 255);
    top: -10px;
    left: -10px;
    z-index: 999;

    span {
      // transition: all 0.5s ease;
      margin: 14px auto;
      display: block;
      width: 36%;
      height: 2px;
      border-radius: 20px;
      background-color: rgba(94, 94, 94, 0.61);
    }

    span:nth-child(1) {
      transform: rotate(45deg);
    }

    span:nth-child(2) {
      transform: translateY(-7px) rotate(-45deg);
    }
  }

  .Yuan-title {
    // transition: all 0.5s ease;
    padding: 0 0 10px 0;
    width: 200px;
    height: 500px;
    overflow-y: auto;
    background-color: #ffffffcb;
    border-radius: 5px;
    position: relative;
    top: 5px;
    left: 5px;
    z-index: 99;
    box-shadow: 0 0 10px 2px rgba(134, 134, 134, 0.39);

    .Yuan-btn {
      width: 80%;
      height: 32px;
      margin: 0 auto 15px;

      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.textEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.btns {
  // background-color: #003565;

  width: 100%;
  height: 60px;
  border-radius: 4px;
  color: #ffffff;
  // margin: 15px auto;
  cursor: pointer;
  overflow: hidden;

  p {
    overflow: hidden;
    font-size: 13px;
    color: #003565;
  }
}

.btnss {
  // background-color: #e6a23c;
  // background: url("assets/img/btnHover.png");
  width: 100%;
  height: 50px;
  border-radius: 4px;
  color: #ec8e00;
  cursor: pointer;
  overflow: hidden;

  p {
    overflow: hidden;
    font-size: 13px;
  }
}

.el-submenu__title i {
  color: #ffffff !important;
}

// 隐藏滚动条
.hiddenScroll::-webkit-scrollbar {
  display: none;
}
</style>

<style lang="less" scoped>
/deep/ .el-submenu .el-menu-item {
  height: 50px;
  line-height: 50px;
  padding: 0 35px !important;
  // background: none !important;
  min-width: 180px;
}

#app {
  width: 100%;
  height: 100%;
}

/deep/ .el-dialog__body .el-row {
  padding: 20px;
}

// 全局
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}

// 应用导航
div#WorkPlaneRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #0092d9;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#WorkPlaneRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#WorkPlaneRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#WorkPlaneRemenu ul li:hover {
  background: #eee;
  color: #000000;
}

#WorkPlaneTree {
  height: 500px;
}

.zTreeDiv {
  overflow: auto;
}

.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}

// 模型菜单
/deep/ .ztree li span.button.pIcon01_ico_open,
/deep/ .ztree li span.button.button.pIcon01_ico_close,
/deep/ .ztree li span.button.pIcon01_ico_docu {
  margin-right: 2px;
  background: url("./assets/img/singleMode.png") no-repeat scroll 3px 1px transparent;
  vertical-align: top;
  background-size: 80%;
  *vertical-align: middle;
}

/deep/ .ztree li span.button.pIcon02_ico_open,
/deep/ .ztree li span.button.button.pIcon02_ico_close,
/deep/ .ztree li span.button.pIcon02_ico_docu {
  margin-right: 2px;
  background: url("./assets/img/dieAssembly.png") no-repeat scroll 0 0 transparent;
  vertical-align: top;
  background-size: cover;
  *vertical-align: middle;
}

/deep/ .ztree li span.button.pIcon03_ico_open,
/deep/ .ztree li span.button.button.pIcon03_ico_close,
/deep/ .ztree li span.button.pIcon03_ico_docu {
  margin-right: 2px;
  background: url("./assets/img/Boxselection.png") no-repeat scroll 0 0 transparent;
  vertical-align: top;
  background-size: cover;
  *vertical-align: middle;
}

/deep/ .ztree li span.button.pIcon04_ico_open,
/deep/ .ztree li span.button.button.pIcon04_ico_close,
/deep/ .ztree li span.button.pIcon04_ico_docu {
  margin-right: 2px;
  background: url("./assets/img/file.png") no-repeat scroll 3px 1px transparent;
  vertical-align: top;
  background-size: 82%;
  *vertical-align: middle;
}

/deep/ .el-menu-item.is-active i {
  color: #ec8e00 !important;
}
</style>